<template>
    <div>
        <el-dialog title="收益明细" fullscreen :visible.sync="incomeDetailDialogVisible" @open="openDialog"
                   @close="closeDialog" :close-on-click-modal="false">
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="userId" fixed="left" label="用户ID"></el-table-column>
                <el-table-column prop="coinNum" label="存入数量"></el-table-column>
                <el-table-column prop="incomeNum" label="收益数量"></el-table-column>
                <el-table-column label="收益结算时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.settlementTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.settlementStatus==0">已发放</span>
                        <span v-if="scope.row.settlementStatus==1">发放失败</span>
                        <span v-if="scope.row.settlementStatus==2">未发放</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                    <template slot-scope="scope">
                        <el-button :disabled="!scope.row.settlementStatus==1" type="primary" @click="supplyIncome(scope.row.id)">补发收益</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapMutations, mapState, mapGetters} from 'vuex';

    export default {
        name: "IncomeDetail",
        data() {
            return {
                dataList: [],
                total: 0,
                queryParams: {poolId: "", page: 1, size: 10},
            }
        },
        computed: {
            ...mapState("NewCoin", ["incomeDetailDialogVisible"])
        },
        methods: {
            ...mapMutations("NewCoin", ["setIncomeDetailDialogVisible", "setPoolId"]),
            ...mapGetters("NewCoin", ["getPoolId"]),
            openDialog() {
                this.queryParams.poolId = this.getPoolId();
                api.getInComeCoinPage(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            closeDialog() {
                this.setIncomeDetailDialogVisible(false);
                this.setPoolId(-1);
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.openDialog();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.openDialog();
            },
            supplyIncome(id){
                this.$confirm('确认补发吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.inComeSupply({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.openDialog();
                    });
                }).catch(() => {
                });
            }
        }
    }
</script>

<style scoped>

</style>